/**
 * Auth provider selection: Zitadel OIDC (staging+) vs legacy OpenAuth.
 * Zitadel is active when ZITADEL_CLIENT_ID is set at runtime (Worker / server).
 */

export type AuthProvider = 'zitadel' | 'openauth'

export function getZitadelDomain(): string {
  return (
    process.env.NEXT_PUBLIC_ZITADEL_DOMAIN ||
    process.env.ZITADEL_DOMAIN ||
    'staging-auth.cloudshuttle.com.au'
  )
}

export function getAppUrl(): string {
  return process.env.NEXT_PUBLIC_APP_URL || 'http://localhost:3000'
}

export function getZitadelRedirectUri(): string {
  return (
    process.env.ZITADEL_REDIRECT_URI || `${getAppUrl().replace(/\/$/, '')}/auth/callback`
  )
}

export function getZitadelClientId(): string | undefined {
  return process.env.ZITADEL_CLIENT_ID
}

/** Zitadel org ID — org login policy + IdPs (authorize `organization` param + org scope URN). */
export function getZitadelOrganizationId(): string | undefined {
  return process.env.ZITADEL_ORGANIZATION_ID
}

/** Server-side: use Zitadel when client id is configured. */
export function getServerAuthProvider(): AuthProvider {
  return getZitadelClientId() ? 'zitadel' : 'openauth'
}

/** Client bundle: Zitadel when public domain is set (paired with server client id in deploy). */
export function getClientAuthProvider(): AuthProvider {
  return process.env.NEXT_PUBLIC_ZITADEL_DOMAIN ? 'zitadel' : 'openauth'
}

export function isZitadelAuth(): boolean {
  return getClientAuthProvider() === 'zitadel'
}
